var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fluent:call-16-filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.1354 10.5361L11.7464 9.06012C12.1869 8.65575 12.4965 8.12897 12.6355 7.54739C12.7745 6.96581 12.7365 6.35596 12.5264 5.79612L11.8394 3.96162C11.5827 3.27675 11.0746 2.7155 10.4186 2.39221C9.7625 2.06892 9.00787 2.00791 8.3084 2.22162C5.7344 3.00912 3.7559 5.40162 4.3649 8.24262C4.7654 10.1116 5.5319 12.4576 6.9839 14.9536C8.4389 17.4556 10.1009 19.3036 11.5259 20.6026C13.6769 22.5601 16.7519 22.0711 18.7304 20.2261C19.2608 19.7316 19.5826 19.0535 19.6302 18.3299C19.6779 17.6064 19.4478 16.8919 18.9869 16.3321L17.7269 14.8021C17.3469 14.3394 16.8371 14.0011 16.2632 13.8305C15.6892 13.66 15.0774 13.6651 14.5064 13.8451L12.4244 14.5006C11.8867 13.9457 11.4155 13.3301 11.0204 12.6661C10.639 11.9947 10.3418 11.2788 10.1354 10.5346V10.5361Z",
    fill: "#E31E24"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallFilled);
export default __webpack_public_path__ + "static/media/call-filled.4db9e49bb742350e9ae080ec0c303026.svg";
export { ForwardRef as ReactComponent };